import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { videos } from 'redux/modules'
import Loader from './Loader'

const VideoLoader = props => {
  const { children, videoId, fetchVideo, ...restProps } = props

  const fetchMethod = params => fetchVideo(videoId, params)
  const triggers = [videoId]

  return (
    <Loader fetchMethod={fetchMethod} triggers={triggers} {...restProps}>
      {children}
    </Loader>
  )
}

VideoLoader.propTypes = {
  children: PropTypes.node.isRequired,
  videoId: PropTypes.string.isRequired,
  fetchVideo: PropTypes.func.isRequired,
}

export default connect(
  null,
  { fetchVideo: videos.fetchVideo }
)(VideoLoader)
